import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { useFormatter } from 'next-intl';
import { Image } from 'react-datocms';
import { Card } from '~/components/Card';
import { Stack } from '~/components/Layout/Stack';
import { Link } from '~/components/Link';
import { trackEvent } from '~/utils';
import { photoGradeClassName } from '~/utils/photoGrade';
import styles from './ImageCard.module.css';
import type { ImageCardProps } from './ImageCard.types';
const ImageCard = t0 => {
  const $ = _c(44);
  const {
    journalPost,
    collectionsTile,
    variant
  } = t0;
  const format = useFormatter();
  if (variant === "journal" && journalPost) {
    const {
      _firstPublishedAt,
      slug,
      title,
      category,
      coverImage,
      excerpt
    } = journalPost;
    const href = `/journal/${slug}`;
    let t1;
    if ($[0] !== coverImage.responsiveImage || $[1] !== coverImage.tags) {
      t1 = coverImage.responsiveImage && <Image data={coverImage.responsiveImage} className={clsx(styles.image, photoGradeClassName(coverImage.tags))} objectFit="cover" layout="responsive" sizes="(max-width: 767px) calc(100vw - 32px), (max-width: 1279px) 50vw, 33vw" />;
      $[0] = coverImage.responsiveImage;
      $[1] = coverImage.tags;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== category) {
      t2 = category && <span className={styles.cardCategory}>{category.title}</span>;
      $[3] = category;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== title) {
      t3 = <div className={styles.headingWrap}><h2 className={styles.title}>{title}</h2></div>;
      $[5] = title;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== _firstPublishedAt || $[8] !== format) {
      t4 = _firstPublishedAt && format.dateTime(new Date(_firstPublishedAt), {
        day: "numeric",
        month: "short",
        year: "numeric"
      });
      $[7] = _firstPublishedAt;
      $[8] = format;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t4) {
      t5 = <span className={styles.subheader}>{t4}</span>;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== excerpt) {
      t6 = <p className={styles.excerpt}>{excerpt}</p>;
      $[12] = excerpt;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t2 || $[15] !== t3 || $[16] !== t5 || $[17] !== t6) {
      t7 = <div className={styles.contentWrapper}><Stack space="--by-space-100">{t2}{t3}{t5}{t6}</Stack></div>;
      $[14] = t2;
      $[15] = t3;
      $[16] = t5;
      $[17] = t6;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== href || $[20] !== t1 || $[21] !== t7) {
      t8 = <Card isElevated={true} rounded="--by-border-radius-400" isFlex={true}><Link href={href} isUnstyled={true}>{t1}{t7}</Link></Card>;
      $[19] = href;
      $[20] = t1;
      $[21] = t7;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    return t8;
  }
  if (variant === "collections" && collectionsTile) {
    const {
      title: title_0,
      backgroundImage,
      excerpt: excerpt_0,
      link,
      isExternal
    } = collectionsTile;
    let t1;
    if ($[23] !== backgroundImage) {
      t1 = backgroundImage?.responsiveImage && <Image data={backgroundImage.responsiveImage} className={clsx(styles.image, photoGradeClassName(backgroundImage.tags))} objectFit="cover" layout="fill" sizes="(max-width: 767px) calc(100vw - 32px), (max-width: 1279px) 50vw, 33vw" />;
      $[23] = backgroundImage;
      $[24] = t1;
    } else {
      t1 = $[24];
    }
    let t2;
    if ($[25] !== title_0) {
      t2 = <div className={styles.inspirationHeadingWrap}><h2 className={styles.title}>{title_0}</h2></div>;
      $[25] = title_0;
      $[26] = t2;
    } else {
      t2 = $[26];
    }
    let t3;
    if ($[27] !== excerpt_0) {
      t3 = <p className={styles.excerpt}>{excerpt_0}</p>;
      $[27] = excerpt_0;
      $[28] = t3;
    } else {
      t3 = $[28];
    }
    let t4;
    if ($[29] !== t2 || $[30] !== t3) {
      t4 = <div className={styles.inspirationContent}><Stack space="--by-space-100">{t2}{t3}</Stack></div>;
      $[29] = t2;
      $[30] = t3;
      $[31] = t4;
    } else {
      t4 = $[31];
    }
    let t5;
    if ($[32] !== t1 || $[33] !== t4) {
      t5 = <>{t1}{t4}</>;
      $[32] = t1;
      $[33] = t4;
      $[34] = t5;
    } else {
      t5 = $[34];
    }
    const tileContent = t5;
    let t6;
    if ($[35] !== title_0) {
      t6 = () => {
        trackEvent("collections_section_tile", {
          event_category: "User_Interaction",
          event_label: "collections_section_tile",
          tile_title: title_0
        });
      };
      $[35] = title_0;
      $[36] = t6;
    } else {
      t6 = $[36];
    }
    let t7;
    if ($[37] !== isExternal || $[38] !== link || $[39] !== tileContent) {
      t7 = link ? <Link href={link} isExternal={isExternal} isUnstyled={true}>{tileContent}</Link> : tileContent;
      $[37] = isExternal;
      $[38] = link;
      $[39] = tileContent;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    let t8;
    if ($[41] !== t6 || $[42] !== t7) {
      t8 = <div className={styles.inspirationCard}><Card isElevated={true} rounded="--by-border-radius-400" isFlex={true} fullHeight={true}><div className={styles.clickableArea} onClick={t6}>{t7}</div></Card></div>;
      $[41] = t6;
      $[42] = t7;
      $[43] = t8;
    } else {
      t8 = $[43];
    }
    return t8;
  }
  return null;
};
export { ImageCard };